import * as types from "./types";
export default (state = [], action) => {
  switch (action.type) {
    case types.FETCH_COMPANY_MASTER_DDLS:
      return action.payload;
    default:
      return state;
  }
};
